import FormBox from './Form';

FormBox.install = function(Vue) {
    Vue.component(FormBox.name, FormBox);
};

export default FormBox;